// extracted by mini-css-extract-plugin
export default {"card":"BarChartCard_card__m5zOh"};